import { EppoExperimentOverrides } from '@moonpig/web-core-utils/src/eppoContext/EppoContext'
import { logger } from '@moonpig/web-core-monitoring'
import { parse } from '../parse-params/parse-params'

export const getEppoExperimentOverrides = (
  variantParams: string[],
  getCookie: (name: string) => string | undefined,
): EppoExperimentOverrides => {
  const overrideParams = parse(variantParams)
  const overrideCookie = getCookie('mnpg_eppo_overrides')

  let cookieOverrides: { [key: string]: string } = {}
  try {
    cookieOverrides = overrideCookie ? JSON.parse(overrideCookie) : {}
  } catch (e) {
    logger.fixToday(`Error parsing override cookie ${overrideCookie}: ${e}`)
  }
  return { ...cookieOverrides, ...overrideParams }
}
